





















































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import NoteTemplate from "@/components/NoteTemplate.vue";
import DebounceAsync from "../utility/DebounceAsync";
import { API } from "aws-amplify";
import TemplateOptions, { SelectorMap } from "@/utility/TemplateOptions";

@Component({
  components: {
    NoteTemplate,
  },
})
export default class NotesPage extends Vue {
  @Prop()
  public title: string;

  @Prop()
  public noteType: string;

  public showTemplate: boolean = false;
  public isLoading: boolean = false;
  public noteContent: string = "";

  private debounceAsync: DebounceAsync = new DebounceAsync();
  private selectors: SelectorMap = {};


  @Watch("state")
  public async getNoteContent() {
    this.saveState();
    if (this.selectors.sex.defined && Object.values(this.selectors).every(x => x.satisfied)) {
      const result = await this.debounceAsync.invoke(async () =>
        this.generateNote(this.noteType)
      );
      if (result != null) {
        this.noteContent = result.note;
        return;
      }
    }
    this.noteContent = "";
  }

  public get state(): string {
    return this.getState();
  }

  private getState(): any {
    const state: SelectorMap = {};
    for (const key of Object.keys(this.selectors)) {
      state[key] = this.selectors[key].value;
    }

    return state;
  }

  public templateSaved(r: any) {
    this.getNoteContent();
  }

  public async created() {
    this.selectors = await new TemplateOptions(this.noteType).getSelectors();
    try {
      this.loadState();
    } catch (e) {
      return;
    }
    this.$emit("selectors", this.selectors);
  }

  private getOptions(): any {
    const options: { [key: string]: any } = {};
    for (const key of Object.keys(this.selectors)) {
      const val = this.selectors[key].getResult();
      if (typeof val === "number") {
        options[key] = val.toFixed(1).replace(/\.0$/, "");
      } else {
        options[key] = val;
      }
    }
    return options;
  }

  protected async generateNote(type: string) {
    const options = this.getOptions();
    console.log(options);
    return await API.post("RestApi", `/api/note/${type}/latest`, {
      body: { options },
    });
  }

  protected saveState() {
    localStorage.setItem(
      `notorious-${this.constructor.name}`,
      JSON.stringify(this.getState())
    );
  }

  private loadState() {
    const state = JSON.parse(
      localStorage.getItem(`notorious-${this.constructor.name}`)!
    );
    for (const key of Object.keys(this.selectors)) {
      if (state.hasOwnProperty(key)) {
        this.selectors[key].value = state[key];
      }
    }
  }

  public clearAll() {
    for (const ctrl of Object.values(this.selectors)) {
      ctrl.clear();
    }
    this.noteContent = "";
  }
}
